export const getPeriodsData = async (api,type) => {
  const response = await api.get(`/reports/periods/${type}`);
  return !response.error ? response : [];
};

export const closeYearForType = async (api, type, year, addToast, closed) => {
  const response = api.post(`/reports/periods/${type}/${year}/close`, { close: closed }, true)
    .then((data) => {
      // eslint-disable-next-line no-unused-expressions
      !!addToast && (closed
        ? addToast.success('Выбранный год был закрыт для редактирования')
        : addToast.success('Выбранный год был открыт для редактирования'));
      return data;
    })

    .catch((err) => !!addToast && addToast.error(err));
  return !response.error ? response : [];
};

export const getPeriodsFields = async (api) => {
  const response = await api.get(`/mng/kpis/periodFields`);
  return !response.error ? response : [];
};

export const changePeriodFieldState = async (api, factNumber, addToast, closed) => {
  const response = api.post(`/mng/kpis/periodFields/${factNumber}`, { code: factNumber, isCurrent: closed }, true)
    .then((data) => {
      !!addToast && (!closed
        ? addToast.success(`Изменение текущего периода прошло успешно.`)
        : addToast.success(`Выбранный период назначен текущим.`));
      return data;
    })

    .catch((err) => !!addToast && addToast.error(err));
  return !response.error ? response : [];
};

export const getFixedPcs = async (api,addToast) =>{
    const response = await api.get (`/mng/fixedPcs`) ;
    return !response.err ? response :(()=>addToast.error(response.err)())
}

export const deleteFixedPcs = async (api,toast,id) => {
    const response = api.delWithPromise(`/mng/fixedPcs/${id}`).then((x)=>{
        // eslint-disable-next-line no-unused-expressions
        !!toast && toast.success('Показатель был удален')
    }).catch((err) => !!toast && toast.error(err))
    return !response.error ? response : [];
}

export const getLastAcceptedProjectVerison = async (api, id,) => {
    const lastProj = await api.get(`/projs/${id}/versions`)
        .then(res=>res.filter(x=>x.status.endsWith('approved')).sort((a,b)=>new Date(b.createdOn).getTime()-new Date(a.createdOn).getTime()))
        .then(x=>x.length ? x[0] : {})
    return lastProj
}

export const getProjById = async (api,id) =>{
    return await api.get(`/projs/${id}?readonly=true`)
}

